// extracted by mini-css-extract-plugin
export default {"main":"_231f9bcd9f _7117cfcfad","xmark":"_390ce55c09","fl_img":"_2f39509df4 _86d7ce98f6"};